import React from 'react';
import { MAX_NAME_LENGTH } from 'reactApp/appHelpers/configHelpers';
import { renderNewFolderModal } from 'reactApp/components/NewFolderModal/NewFolderModal.helpers';
import { vigboAlbumErrors } from 'reactApp/modules/vigbo/vigbo.constants';
import { createVigboAlbumRequest } from 'reactApp/modules/vigbo/vigbo.module';
import { store as reduxStore } from 'reactApp/store';
import { getDefaultAlbumName } from 'reactApp/utils/formatDate';

import styles from './VigboPage.css';

export interface RenderNewVigboAlbumModalProps {
    onClose?: () => void;
    navigateToAlbum: boolean;
}

export const renderNewVigboAlbumModal = (props: RenderNewVigboAlbumModalProps) => {
    const { onClose, navigateToAlbum } = props;
    renderNewFolderModal({
        onClose,
        showShareButton: false,
        showCreateButton: true,
        title: () => (
            <div className={styles.titleWrapper}>
                <div>Создание галереи Vigbo</div>
                <div className={styles.subTitle}>Фото появятся в Облаке и Vigbo</div>
            </div>
        ),
        placeholder: 'Введите название галереи',
        folderName: getDefaultAlbumName(),
        createFolder: async (name: string) => {
            const title = name.trim();

            if (!title.length) {
                return Promise.reject(vigboAlbumErrors.getMessage('required'));
            }

            if (title.length > MAX_NAME_LENGTH) {
                return Promise.reject(vigboAlbumErrors.getMessage('name_too_long'));
            }

            reduxStore.dispatch(createVigboAlbumRequest({ title, navigateToAlbum }));
        },
    });
};
